import React from 'react';

export const SvgHere = (props) => (
  <svg
    overflow='hidden'
    viewBox='0 0 1236 653'
    xmlns='http://www.w3.org/2000/svg'
    width='100%'
    height='100%'
    {...props}
  >
    <defs>
      <clipPath id='Here_svg__a'>
        <path d='M131 1494h1239v655H131z' />
      </clipPath>
    </defs>
    <g
      transform='matrix(.99793 0 0 .99758 -130.94 -1490.6)'
      clipPath='url(#Here_svg__a)'
    >
      <path
        d='M133.5 1604.8c0-59.84 48.503-108.34 108.34-108.34h1017.3c59.84 0 108.34 48.5 108.34 108.34v433.32c0 59.84-48.5 108.34-108.34 108.34H241.84c-59.832 0-108.34-48.5-108.34-108.34z'
        fillRule='evenodd'
        stroke='#4472c4'
        strokeMiterlimit={8}
        strokeWidth={4.583}
      />
    </g>
    <g
      style={{
        fill: '#fff',
        strokeLinejoin: 'round',
        strokeWidth: 312.25
      }}
      aria-label='\u73FE\u5728\u5730'
    >
      <path d='M170.18 391.45q27.711-4.82 45.783-8.434v-65.059h-37.349v-22.89h37.349V231.21H172.59v-22.89h107.23v22.89h-39.759v63.855h33.735v22.891h-33.735v60.24l38.554-10.843 6.024 20.482q-51.807 16.867-98.794 28.915-3.614 8.434-7.229 3.615zm236.14-145.78v-28.915h-91.565v28.915zm0 48.192v-28.915h-91.565v28.915zm0 48.192v-28.915h-91.565v28.915zm-34.939 19.277H348.49v12.048q0 73.493-113.25 86.746l-8.434-26.506q97.59-8.434 97.59-61.445v-10.843H290.66v-163.85h139.76v163.85h-34.939v63.855q0 9.638 8.434 9.638h8.434q7.228 0 9.638-7.228 2.41-7.23 4.82-28.915l25.3 7.228q-2.41 16.867-4.819 26.506-6.024 25.301-24.096 25.301h-31.325q-20.482 0-20.482-20.482zM531.62 283.02l15.662 3.614q7.229-7.228 22.891-36.144h-78.312V227.6h87.951q9.638-22.892 14.458-43.374l26.506 9.639q4.82 4.819-3.614 6.024-2.41 10.843-10.843 27.71h139.76v22.89h-149.4q-14.458 32.53-40.963 67.47v142.17H531.62v-119.28q-15.662 15.662-44.578 32.53l-12.048-27.711q33.735-15.662 56.626-40.963zm136.14-15.662q9.638 1.205 1.205 7.229v46.987h61.445v22.89h-61.445v79.518h79.517v22.89h-181.93v-22.89h78.312v-79.517H578.6v-22.891h66.264v-54.216zM885.84 395.06l-80.722 28.915q-1.205 8.434-6.024 3.614l-9.638-27.71 37.349-10.844v-97.589h-34.94v-22.89h34.94v-67.47h22.89q9.639 1.205 1.205 7.23v60.24h31.325v22.89H850.9v91.565l34.94-12.048zm132.53 34.939q12.048 0 15.662-12.048l7.229-25.301 26.506 8.434-6.024 22.89q-7.229 28.916-34.94 28.916h-99.998q-21.686 0-21.686-20.482v-114.46l-31.325 12.048-7.229-24.096 38.554-13.253v-68.674h22.891q9.638 1.204 1.205 7.228v53.011l28.915-10.843v-81.927h22.89q9.64 1.205 1.206 7.23v66.263l40.963-15.662 2.41-4.819 25.3 16.867-4.819 3.614V356.5q0 19.277-19.277 19.277h-24.096l-6.024-22.89h20.482q4.82 0 4.82-4.82V275.78l-39.76 14.458v103.61H958.13v-95.18l-28.915 10.843v110.84q0 9.639 8.434 9.639z' />
    </g>
  </svg>
);
